import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import {
  addTagToAsset,
  confirmTag,
  removeTagFromAsset,
} from '~/domain/asset-details-common/store/mapDetails/reducerHelpers/handleTagUpdatesInDetails';
import type {
  removeAssetTagRelationshipsAction,
  addAssetTagRelationshipsAction,
} from '~/ducks/asset-tag-relationships/actions';
import AssetTagRelationshipsConstants from '~/ducks/asset-tag-relationships/constants';
import type { NoInfer } from '~/types/helper.types';
import type { Fields } from '../../data/AssetListRecord';
import { findAssetIndex } from '../asset-list-selectors';

export const addHandlerForTagUpdates = (builder: ActionReducerMapBuilder<NoInfer<Fields>>) => {
  // @ts-ignore
  builder.addCase(
    AssetTagRelationshipsConstants.ADD_ASSET_TAG_RELATIONSHIPS_REQUEST_SUCCESS,
    (state, action: ReturnType<typeof addAssetTagRelationshipsAction>) => {
      action.payload.assets.forEach((assetId) => {
        const index = findAssetIndex(state.assets, assetId);
        if (index === -1) {
          return true;
        }

        confirmTag(state.assets[index], action.payload.tagCategory, action.payload.tag);
      });
    }
  );

  // @ts-ignore
  builder.addCase(
    AssetTagRelationshipsConstants.ADD_ASSET_TAG_RELATIONSHIPS_REQUEST_ERROR,
    (state, action: ReturnType<typeof addAssetTagRelationshipsAction>) => {
      action.payload.assets.forEach((assetId) => {
        const index = findAssetIndex(state.assets, assetId);
        if (index === -1) {
          return true;
        }

        removeTagFromAsset(
          state.assets[index],
          action.payload.tagCategory,
          action.payload.tag,
          true
        );
      });
    }
  );

  // @ts-ignore
  builder.addCase(
    AssetTagRelationshipsConstants.REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST,
    (state, action: ReturnType<typeof addAssetTagRelationshipsAction>) => {
      action.payload.assets.forEach((assetId) => {
        const index = findAssetIndex(state.assets, assetId);
        if (index === -1) {
          return true;
        }

        removeTagFromAsset(state.assets[index], action.payload.tagCategory, action.payload.tag);
      });
    }
  );

  builder.addMatcher(
    (action): action is any =>
      [
        AssetTagRelationshipsConstants.REMOVE_ASSET_TAG_RELATIONSHIPS_REQUEST_ERROR,
        AssetTagRelationshipsConstants.ADD_ASSET_TAG_RELATIONSHIPS_REQUEST,
      ].includes(action.type),
    (state, action: ReturnType<typeof removeAssetTagRelationshipsAction>) => {
      action.payload.assets.forEach((assetId) => {
        const index = findAssetIndex(state.assets, assetId);
        if (index === -1) {
          return true;
        }

        addTagToAsset(state.assets[index], action.payload.tagCategory, action.payload.tag);
      });
    }
  );
};
